import React, { useState } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { base64 } from '../utils/textUtils';

const Base64Tool: React.FC = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [mode, setMode] = useState<'encode' | 'decode'>('encode');
  const [showToast, setShowToast] = useState(false);

  const handleConvert = () => {
    const converted = mode === 'encode' ? base64.encode(text) : base64.decode(text);
    setResult(converted);
  };

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  const handleClear = () => {
    setText('');
    setResult('');
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">
            Base64 인코딩
          </h1>
          <p className="text-textSecondary">Base64 인코딩/디코딩</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <div className="flex gap-12 mb-24">
            <Button
              onClick={() => {
                setMode('encode');
                setResult('');
              }}
              variant={mode === 'encode' ? 'primary' : 'secondary'}
            >
              인코딩
            </Button>
            <Button
              onClick={() => {
                setMode('decode');
                setResult('');
              }}
              variant={mode === 'decode' ? 'primary' : 'secondary'}
            >
              디코딩
            </Button>
          </div>

          <label className="block text-textSecondary mb-8 text-sm">
            {mode === 'encode' ? '일반 텍스트 입력' : 'Base64 문자열 입력'}
          </label>
          <Textarea
            value={text}
            onChange={setText}
            placeholder={
              mode === 'encode'
                ? '일반 텍스트를 입력하세요...'
                : 'Base64 문자열을 입력하세요...'
            }
          />

          {text && (
            <div className="mt-16">
              <Button onClick={handleConvert}>
                {mode === 'encode' ? '인코딩' : '디코딩'}하기
              </Button>
            </div>
          )}
        </motion.div>

        {result && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <div className="text-center mb-16 text-2xl text-textSecondary">↓</div>
            <label className="block text-textSecondary mb-8 text-sm">
              {mode === 'encode' ? 'Base64 결과' : '디코딩 결과'}
            </label>
            <Textarea value={result} onChange={setResult} />
            <div className="flex gap-12 mt-12">
              <Button onClick={handleCopy}>결과 복사</Button>
              <Button onClick={handleClear} variant="secondary">
                초기화
              </Button>
            </div>
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default Base64Tool;
